<template>
  <div>
    <wt-dropdown
      :items="programmers"
      :type="type"
      :on-click-item="changeProgrammer"
      :current-item-id="currentProgrammerId"
      :disabled="disabled"
      v-if="showProgrammersList"
      class="wt2-programmers-dropdown align-self-center"
    >
      <template slot="item" slot-scope="props">
        <span v-text-right>{{ props.item.label }}</span>
      </template>
    </wt-dropdown>
  </div>
</template>

<script>
import app from 'app';
import { mapState } from 'vuex';

export default {
  store() {
    return app.rootStore;
  },
  props: {
    enableStash: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'underline fixed',
    },
    organizationId: {
      type: Number,
      required: true,
    },
    initialProgrammerId: {
      type: Number,
      required: false,
    },
    currentProgrammerId: {
      type: Number,
      required: false,
    },
    showSingleProgrammer: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.initProgrammerId();
  },
  watch: {
    organizationId(orgId) {
      this.setProgrammerId();
    },
  },

  data() {
    return {
      selectedProgrammerId: 0,
    };
  },
  computed: {
    currentOrganization() {
      let org = this.organizations.find(
        (org) => org.organizationId === this.organizationId
      );
      if (!org) {
        org = this.organizations[0];
      }
      return org;
    },

    programmers() {
      return this.currentOrganization.programmers.map((p) => ({
        id: p.programmerId,
        label: p.label,
      }));
    },

    showProgrammersList() {
      return this.programmers.length > (this.showSingleProgrammer ? 0 : 1);
    },

    disabled() {
      return this.programmers.length === 1;
    },

    currentProgrammerInOrg() {
      return !!this.currentOrganization.programmers.find(
        ({ programmerId }) => programmerId === this.currentProgrammerId
      );
    },

    ...mapState('user', ['organizations']),
  },
  methods: {
    initProgrammerId() {
      if (this.initialProgrammerId) {
        this.setProgrammerId(this.initialProgrammerId);
      } else if (this.currentProgrammerId) {
        this.setProgrammerId(this.currentProgrammerId);
      } else {
        this.setProgrammerId();
      }
    },
    setProgrammerId(definedProgrammerId) {
      let selectedProgrammer;
      let id;
      if (definedProgrammerId) {
        selectedProgrammer = this.programmers.find(
          (p) => p.id === definedProgrammerId
        );
      } else if (this.enableStash) {
        id = app.stash.get('last-selected-programmer');
        selectedProgrammer = this.programmers.find((p) => p.id === id);
        if (!selectedProgrammer) {
          selectedProgrammer = this.programmers[0];
          app.stash.set('last-selected-programmer', selectedProgrammer.id);
        }
      } else {
        selectedProgrammer = this.programmers[0];
      }

      this.changeProgrammer(selectedProgrammer.id);
    },
    changeProgrammer(programmerId) {
      if (this.enableStash) {
        app.stash.set('last-selected-programmer', programmerId);
      }
      this.$emit('update:currentProgrammerId', programmerId);
    },
  },
};
</script>

<style lang="scss">
.wt2-sg .single-programmer.underline {
  > span.wt2-dropdown-button {
    padding-top: 17px;
    display: block;
  }
}
</style>
